var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "42px",
    viewBox: "0 0 28 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000206704235%",
    y1: "49.9999684%",
    x2: "100.000001%",
    y2: "49.9999684%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#268072",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "45.1967473%",
    x2: "100%",
    y2: "45.1967473%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FBAD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258474",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaigns_Events",
    transform: "translate(-82.000000, -20.000000)",
    fill: "url(#linearGradient-1)",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_clasic",
    transform: "translate(82.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68677407,5.22444035 C0.847729834,5.58635827 0.308157838,6.38638079 0.308157838,7.26846973 L0.308157838,14.3841039 C0.308157838,18.3104068 0.929546434,22.2141914 2.15118441,25.9619748 L2.15118441,29.0244535 L10.6903843,40.7450649 L8.66310724,22.3102692 L8.20026277,22.0884647 C5.87664523,20.974438 4.8857118,19.7398565 4.53978547,17.2713586 L4.53978547,17.1381257 L10.0145818,20.3077734 L10.681772,25.890542 C10.6875135,25.9368294 10.7087832,25.9798643 10.7428408,26.0131412 L13.8082883,29.0095664 L16.8734748,26.0131412 C16.9075325,25.9798643 16.9289327,25.9368294 16.9342827,25.890542 L17.6017339,20.3077734 L23.1240282,17.4619447 C22.7782324,19.9304426 21.7398009,20.974438 19.4161834,22.0884647 L18.9532084,22.3102692 L16.9259314,40.7450649 L25.4650008,29.0244535 L25.4650008,25.9619748 C26.6867692,22.2141914 27.3081578,18.3104068 27.3081578,14.3841039 L27.3081578,7.26846973 C27.3081578,6.38638079 26.7685858,5.58635827 25.9295416,5.22444035 L17.132626,1.42924361 C16.0755346,0.973124438 14.9418462,0.745064852 13.8082883,0.745064852 C12.6745999,0.745064852 11.5409115,0.973124438 10.4836897,1.42924361 L1.68677407,5.22444035 Z M3.19496588,28.7095736 L3.19496588,25.9619748 L3.19496588,25.8091011 L3.14772887,25.6633581 C1.95610336,22.0082748 1.3520698,18.2134533 1.3520698,14.3841039 L1.3520698,7.26846973 C1.3520698,6.78107525 1.65167253,6.3370909 2.11529994,6.13705399 L10.9120851,2.34185726 C11.8287703,1.94641219 12.8031316,1.74587488 13.8082883,1.74587488 C14.8131841,1.74587488 15.7876759,1.94641219 16.7042306,2.34185726 L25.5014072,6.13705399 C25.9647736,6.3370909 26.2642459,6.78107525 26.2642459,7.26846973 L26.2642459,14.3841039 C26.2642459,18.2134533 25.6602123,22.0082748 24.4688478,25.6633581 L24.4210888,25.8091011 L24.4210888,25.9619748 L24.4210888,28.7095736 L18.3885826,36.9896503 L19.9313539,22.9601702 C22.5404814,21.6902674 23.7689048,20.3776796 24.1586754,17.5951775 L24.4688478,15.3808853 L22.5389155,16.6330238 L17.0164908,19.4788525 L16.6192823,19.7368113 L16.5646074,20.1939313 L15.9296479,25.5064811 L13.8082883,27.5801595 L11.6867982,25.5064811 L11.0517083,20.1939313 L10.9971639,19.7368113 L10.5998249,19.4788525 L5.12502861,16.3092048 L3.19496588,15.0570664 L3.50513823,17.2713586 C3.89490885,20.0538607 5.07596475,21.6902674 7.68496173,22.9601702 L9.22773312,36.9896503 L3.19496588,28.7095736 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMask);
export default __webpack_public_path__ + "static/media/logo-mask.25aa49c62dfcb1b2d2870d1547cc3a16.svg";
export { ForwardRef as ReactComponent };